import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PriceFormatPipe } from '@/common/pipes/price-format.pipe';
import { DriversSalaryV2StateService } from '../_services/drivers-salary-v2.state.service';

@Component({
	selector: 'app-salary-pending-drafts',
	standalone: true,
	imports: [
		CommonModule,
		MatButtonModule,
		MatIconModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
		PriceFormatPipe,
	],
	templateUrl: './salary-pending-drafts.component.html',
	styleUrl: './salary-pending-drafts.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SalaryPendingDraftsComponent {
	readonly state = inject(DriversSalaryV2StateService);

	readonly rejectTooltip = 'Odrzucona propozycja nie pojawi się ponownie przy tej samej wartości.';
	readonly acceptTooltip = 'Zapisuje pokazaną kwotę w rozliczeniu miesiąca.';
	readonly pullApplyTooltip = 'Pobiera aktualne dane ze źródła i zapisuje wszystkie brakujące pozycje.';
}
